import BadResponseError from '../errors/BadResponseError';
import JSONResponseParseError from '../errors/JSONResponseParseError';
export default class JSONResponseHandler {
    async handleResponse(response) {
        if (!response.ok) {
            throw new BadResponseError(response);
        }
        const contentType = response.headers.get('content-type');
        if (!contentType || !contentType.includes('application/json')) {
            throw new BadResponseError(response);
        }
        try {
            const data = await response.json();
            return data;
        }
        catch (error) {
            throw new JSONResponseParseError(response, error);
        }
    }
}
